<script lang="ts">
    import { DEFAULT_BOX } from '$lib/components/constants';

    import Emoji from './Emoji.svelte';
    import Icon from '../Icon/Icon.View.svelte';

    export let emoji = '';
    export let icon = '';
    export let srcType = '';
    export let iconName = '';
    export let platform = '';
    export let iconColor = '#000000';
    export let svg = '';
    export let isAnimated = false;
    export let jsonUrl: string | null = null;
</script>

{#if srcType === 'icon' && icon}
    <div style="width: 20px; height: 20px;">
        <Icon
            box={DEFAULT_BOX}
            layout={{
                isInList: true,
                isInColumn: false,
                isInFramedColumn: false,
                isInMultiColumn: false,
                isInSingleColumn: false,
                columnCount: 1,
            }}
            color={iconColor}
            {icon}
            {svg}
            {platform}
            {iconName}
            {isAnimated}
            {jsonUrl}
            transitionEffect="none"
        />
    </div>
{:else}
    <!-- Prefer emoji over icon for backwards compatibility -->
    <Emoji emoji={emoji || icon} size="20px" />
{/if}
